export default __webpack_public_path__ + "static/media/MC.fed9edeb.svg";